/**
 * NadLab hub — featured post carousel (80% slide + 20% peek)
 */
(function () {
  'use strict';

  function initCarousel() {
    var root = document.querySelector('[data-nadlab-carousel]');
    if (!root) return;

    var track = root.querySelector('[data-nadlab-carousel-track]');
    var slides = root.querySelectorAll('[data-nadlab-carousel-slide]');
    var prevBtn = root.querySelector('[data-nadlab-carousel-prev]');
    var nextBtn = root.querySelector('[data-nadlab-carousel-next]');
    var dotsContainer = root.querySelector('[data-nadlab-carousel-dots]');

    if (!track || slides.length === 0) return;

    var isSingle = slides.length <= 1 || root.classList.contains('nadlab-carousel--single');
    var index = 0;
    var autoplayMs = 6000;
    var timer = null;

    function slideStep() {
      var slide = slides[0];
      return slide ? slide.offsetWidth : 0;
    }

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      if (isSingle) {
        track.style.transform = 'translateX(0)';
      } else {
        track.style.transform = 'translateX(-' + index * slideStep() + 'px)';
      }
      slides.forEach(function (slide, idx) {
        slide.classList.toggle('is-active', idx === index);
        slide.setAttribute('aria-hidden', idx === index ? 'false' : 'true');
      });
      if (dotsContainer) {
        dotsContainer.querySelectorAll('[data-nadlab-carousel-dot]').forEach(function (dot, idx) {
          dot.classList.toggle('is-active', idx === index);
          dot.setAttribute('aria-selected', idx === index ? 'true' : 'false');
        });
      }
    }

    function next() {
      goTo(index + 1);
    }

    function prev() {
      goTo(index - 1);
    }

    function startAutoplay() {
      stopAutoplay();
      if (slides.length > 1) {
        timer = setInterval(next, autoplayMs);
      }
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (dotsContainer && slides.length > 1) {
      slides.forEach(function (_, idx) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'nadlab-carousel__dot' + (idx === 0 ? ' is-active' : '');
        dot.setAttribute('data-nadlab-carousel-dot', '');
        dot.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
        dot.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
        dot.addEventListener('click', function () {
          goTo(idx);
          startAutoplay();
        });
        dotsContainer.appendChild(dot);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      var diff = e.changedTouches[0].screenX - touchStartX;
      if (Math.abs(diff) > 50) {
        if (diff < 0) next();
        else prev();
      }
      startAutoplay();
    }, { passive: true });

    window.addEventListener('resize', function () {
      goTo(index);
    });

    goTo(0);
    startAutoplay();
  }

  document.addEventListener('DOMContentLoaded', initCarousel);
})();
